export function manageStorageItem(
  sessionStorageKey: string,
  itemCreator: () => string
) {
  function setAndReturnNewItem() {
    const item = itemCreator();

    sessionStorage.setItem(sessionStorageKey, item);

    return item;
  }

  function getExistingItem() {
    return sessionStorage.getItem(sessionStorageKey);
  }

  function deleteItem() {
    return sessionStorage.removeItem(sessionStorageKey);
  }

  return {
    setAndReturnNewItem,
    getExistingItem,
    deleteItem,
  };
}
